<template>
    <div :id="slotContainerId" v-show="showContainer" class="doc-recipients-dropdown-container">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'DropdownContainer',
    props: {
        showContainer: {
            type: Boolean,
            default: false
        },
        preventCloseElementIds: { 
            // this array contains a list of element ids that, if they get clicked, 
            // they prevent the dropdown to get closed even if the element is not contained by this component
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            slotContainerId: "slot-container",
        }
    },
    computed: {
    },
    created() {
        window.addEventListener("click", this.closeDropdown);
    },
    destroyed() {
        window.removeEventListener('click', this.closeDropdown);
    },
    methods: {
        closeDropdown(ev) {
            if (!this.isInContainer(this.slotContainerId, ev.target)) {
                let elementFound = false;

                for (let i = 0; i < this.preventCloseElementIds.length; i++) {
                    if (this.isInContainer(this.preventCloseElementIds[i], ev.target)) {
                        elementFound = true;
                        break;
                    }
                }

                if (!elementFound) {
                    this.$emit("closeDropdown");
                }
            }
        },
        isInContainer(containerId, target) {
            let node = target;
            while(node) {
                if (node.id === containerId) return true;
                node = node.parentElement;
            }
            return false;
        }
    }
}
</script>

<style lang="scss">
.doc-recipients-dropdown-container {
  position: absolute;
  top: -0.5rem;
  left: 0.5rem;
  z-index: 10;
  background: white;
  border-radius: $radiusMd;
  box-shadow: $tooltipShadow;

  .os-host { 
        .os-content {
            padding: 0.5rem 0px !important;
        }
    } 
}
</style>